export class Localidades {
    lonIdLocalidad!: string;
    intCodigoPostal!: string;
    lonIdMunicipio!: string;
    strLocalidad!:string;
    strMunicipio!:string;
}